import { Pagination } from '@/constants/pagination';
import { PaginationAPI } from '@/types/pagination';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type OrderState = {
  data: OrderType[];
  pagination: PaginationAPI;
  totalElements?: number;
  loading: boolean;
  filters: OrderFilterState;
};

export const orderInitialState: OrderState = {
  data: [],
  pagination: {
    pageNumber: Pagination.pageNumber,
    totalPages: 0,
    totalElements: 0,
    pageSize: Pagination.pageSize,
  },
  loading: false,
  filters: {},
};

const slice = createSlice({
  name: 'order',
  initialState: orderInitialState,
  reducers: {
    setListOrderAction(
      state,
      {
        payload,
      }: PayloadAction<{
        data: OrderType[];
        pagination?: PaginationAPI;
        totalElements?: number;
        append?: boolean;
      }>,
    ) {
      if (payload.append) {
        state.data = [...state.data, ...payload.data];
      } else {
        state.data = payload.data;
      }

      state.pagination = payload.pagination || state.pagination;
      state.totalElements = payload.pagination?.totalElements;
    },

    setOrderLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },

    setOrderFiltersAction(state, action: PayloadAction<OrderFilterState>) {
      state.filters = { ...state.filters, ...action.payload };
    },

    resetOrderFiltersAction(state) {
      state.filters = {};
    },
  },
});

export const {
  setListOrderAction,
  setOrderLoading,
  setOrderFiltersAction,
  resetOrderFiltersAction,
} = slice.actions;

export default slice.reducer;
